/**
 * @generated SignedSource<<da8c9a402e92002300a0be6ea274bc4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationTomraScreenDecativateMutation$variables = Record<PropertyKey, never>;
export type IntegrationTomraScreenDecativateMutation$data = {
  readonly store: {
    readonly deactivateIntegrationTomra: boolean | null;
  };
};
export type IntegrationTomraScreenDecativateMutation = {
  response: IntegrationTomraScreenDecativateMutation$data;
  variables: IntegrationTomraScreenDecativateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deactivateIntegrationTomra",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationTomraScreenDecativateMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "IntegrationTomraScreenDecativateMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "fe5c3e28d028d894d4b1490ab1c1fd42",
    "id": null,
    "metadata": {},
    "name": "IntegrationTomraScreenDecativateMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationTomraScreenDecativateMutation {\n  store {\n    deactivateIntegrationTomra\n  }\n}\n"
  }
};
})();

(node as any).hash = "48e86968ee2e8993bed72ae0fec64d79";

export default node;
